import React from 'react';
import ComplianceLicenseExpirationReport from "../elements/ComplianceLicenseExpirationReport";
class ComplianceLicenseExpiration extends React.Component {
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role=decodedToken.UserRoleName;
        return (
           <>
                    {role==="broker"?            <ComplianceLicenseExpirationReport userPermandMasters={this.props.userPermandMasters} type="bsu" user_Type="B" title="Compliance Expiration Report"></ComplianceLicenseExpirationReport>
:            <ComplianceLicenseExpirationReport userPermandMasters={this.props.userPermandMasters} type="bsu" user_Type="A" title="Compliance Expiration Report"></ComplianceLicenseExpirationReport>
}
                  </>
        );
    }
}
export default ComplianceLicenseExpiration;